import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import location from '@atlassian/jira-common-location/src/index.tsx';
import type { User } from '../../common/model/types.tsx';
import type { State } from '../reducer.tsx';
import type { ProjectState } from './reducer.tsx';
import type { DefaultAssignee } from './types.tsx';

export const get = (state: State): ProjectState => state.project;
export const getProjectKey = (state: State): string => state.project.key;
export const getProjectId = (state: State): number => state.project.id;
export const getProjectName = (state: State): string => state.project.name;
export const getProjectType = (state: State): ProjectType => state.project.type;
export const getProjectDefaultAssignee = (state: State): DefaultAssignee | undefined =>
	state.project.defaultAssignee;
export const getProjectLead = (state: State): User | undefined => state.project.lead;
export const getProjectLeadName = (state: State): string | undefined =>
	state.project.lead && state.project.lead.displayName;
export const isComponentAdminContext = (): boolean => {
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	const pathname = (location() && location().pathname) || '';
	return pathname.endsWith && pathname.endsWith('/administer-components');
};
